import { AuthContext } from 'constants/contexts';
import http from 'services/http';
import { getDeviceType } from './layout';
import { isApp } from './app';

export function loadScript({
  url,
  onLoad = () => { },
  async = false,
}) {
  const script = document.createElement('script');
  script.onload = onLoad;
  script.src = url;
  script.async = async;

  document.head.appendChild(script);
}

export function loadGTM(id) {
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = l != 'dataLayer' ? `&l=${l}` : '';
    j.async = true;
    j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
    f.parentNode.insertBefore(j, f);
  }(window, document, 'script', 'dataLayer', id));
}

export const loadCrispChat = async (crispId) => {
  if (isApp()) {
    return;
  }
  const userInfo = AuthContext.getUser();
  if (!crispId) {
    crispId = (await http.get('v1/organizations/{{organizationId}}/get_crisp_key/').then((res) => res.data.data.crisp_public_key));
    if (!crispId) return;
  }
  window.$crisp = [];
  if (!window.CRISP_LOAD_STARTED) {
    window.CRISP_LOAD_STARTED = true;
    window.CRISP_WEBSITE_ID = crispId;
    loadScript({ url: 'https://client.crisp.chat/l.js', async: true });
    window.$crisp.push(['set', 'user:email', [userInfo?.email]]);
    window.$crisp.push(['set', 'user:phone', [userInfo?.phone]]);
    window.$crisp.push(['set', 'user:nickname', [userInfo?.name]]);
    if (getDeviceType() !== 'DESKTOP') {
      const hideChat = () => {
        window.$crisp?.push(['do', 'chat:hide']);
        window.$crisp.push(['on', 'chat:closed', hideChat]);
      };
      if (window.$crisp) {
        hideChat();
      } else {
        window.CRISP_READY_TRIGGER = function () {
          hideChat();
        };
      }
    }
  }
};
